module.exports = __webpack_public_path__ + "media/images/tmp/lifestyle-65a00ee197a49863a583c905ca20a80c.png";